import React from 'react';
const Error = () => <div>Error...</div>;

const withErrorState = Component => props =>
  props.error ? <Error {...props} /> : <Component {...props} />;

export default withErrorState;
